import { render, staticRenderFns } from "./price-input.vue?vue&type=template&id=77ec7cc1&scoped=true&"
import script from "./price-input.vue?vue&type=script&lang=js&"
export * from "./price-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ec7cc1",
  null
  
)

export default component.exports